export default __webpack_public_path__ + "static/media/aqua9.dc638d8a.png";